import React from "react";
import PulseLoader from "react-spinners/PulseLoader";

const Loadersspinners = () => {
  return (
    <>
      <PulseLoader
        color="#36d69e"
        cssOverride={{}}
        margin={5}
        size={34}
       
      />
    </>
  );
};

export default Loadersspinners;
